import { Card, Content, Grid, Heading, Icon, Tab, Tabs } from "@jobber/components";
import { Page } from "@jobber/components/Page";
import React from "react";
import GeneralSettingsTab from "./tabs/GeneralSettingsTab";
import ServiceAreasSettingsTab from "./tabs/ServiceAreasSettingsTab";
import TimeOffsSettingsTab from "./tabs/TimeOffsSettingsTab";

export default function PageSettings () {
  return (
    <Page title="Settings">
      <Content type={'div'}>
        <Tabs>
          <Tab label="General">
            <Grid>
              <Grid.Cell size={{ xs: 12, sm: 12, md: 8 }}>
                <GeneralSettingsTab />
              </Grid.Cell>
            </Grid>
          </Tab>
          <Tab label="Service Areas">
            <Grid>
              <Grid.Cell size={{ xs: 12, sm: 12, md: 8 }}>
                <ServiceAreasSettingsTab />
              </Grid.Cell>
            </Grid>
          </Tab>
          <Tab label="Time Offs">
            <Grid>
              <Grid.Cell size={{ xs: 12, sm: 12, md: 8 }}>
                <Card>
                  <Content>
                    <TimeOffsSettingsTab />
                  </Content>
                </Card>
              </Grid.Cell>
            </Grid>
          </Tab>
        </Tabs>
      </Content>
    </Page>
  )
}
